import { render, staticRenderFns } from "./ExpandableSection.vue?vue&type=template&id=8e635a38&"
import script from "./ExpandableSection.vue?vue&type=script&lang=js&"
export * from "./ExpandableSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports